<!-- Overlay + Dialog wrapper -->
<div *ngIf="showConfirm" class="fixed inset-0 z-[1000] pointer-events-auto">
    <!-- Overlay -->
    <div class="absolute inset-0 bg-black/40"></div>
    <!-- Dialog -->
    <div class="absolute inset-0 flex items-center justify-center z-[1001]">
        <div class="bg-white w-[300px] rounded-lg shadow-lg overflow-hidden">
            <!-- Header -->
            <div class="px-4 py-3 border-b font-semibold text-center">
                {{title | translate }}
            </div>
            <!-- Body -->
            <div class="px-4 py-4 text-center text-sm leading-relaxed" *ngIf="!copyText">
                <div [innerHTML]="message | translate">

                </div>
            </div>
            <div *ngIf="copyText" class="px-4 py-4 text-center text-sm leading-relaxed">
                <p-inputgroup>
                    <input pInputText [value]="message" readonly />
                    <p-inputgroup-addon>
                        @if(!copySuccess){
                        <button class="flex items-center" (click)="copy(message)"> <i class="pi pi-copy"></i></button>
                        }
                        @else {
                        <button class="flex items-center" disabled> <i class="pi pi-check text-green-500"></i></button>
                        }
                    </p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <!-- Footer -->
            <div class="flex border-t" *ngIf="showCancel">
                <button class="flex-1 py-2 text-sm border-r hover:bg-gray-100" (click)="onCancel()">{{btnCancelText |
                    translate}}</button>
                <button class="flex-1 py-2 text-sm text-white bg-gray-800 hover:bg-gray-700"
                    (click)="onConfirm()">{{btnText | translate}}</button>
            </div>
            <div class="flex border-t" *ngIf="!showCancel">
                <button class="w-full py-2 text-sm text-white bg-gray-800 hover:bg-gray-700"
                    (click)="onConfirm()">{{btnText | translate}}</button>
            </div>
        </div>
    </div>

</div>